import {
  BooleanField,
  Datagrid,
  DateField,
  FunctionField,
  Pagination,
  ReferenceManyField,
  TextField,
  useGetManyReference,
  useRecordContext,
} from "react-admin";
import { Typography } from "@mui/material";

const GetInvitationHistory = ({ reference = "onpoint_extraction_software_invitation_history" }) => {
  const record = useRecordContext();
  const { data, isLoading } = useGetManyReference(reference, {
    target: 'master_customer_id',
    id: record?.id,
    pagination: { page: 1, perPage: 10 },
    sort: { field: 'id', order: 'DESC' },
  });

  if (isLoading) return null;

  if (!data || data.length === 0) {
    return <Typography sx={{ m: 2 }}>No OnPoint invitations found</Typography>;
  }

  return (
    <ReferenceManyField
      fullWidth
      label="Invitations"
      reference={reference}
      target="master_customer_id"
      source="id"
      perPage={10}
      sort={{ field: "id", order: "DESC" }}
      pagination={<Pagination />}
    >
      <Datagrid>
        <TextField source="id" />
        <DateField
          source="date_added"
        />
        <TextField source="status" />
        <TextField source="invitation_email_send_to" />
        <TextField source="recipient_name" label="Recipient" />
        <BooleanField source="accepted_center_store_participation" />
        <BooleanField source="interested_in_patron_points_tobacco" />
        <BooleanField source="accepted_eula" />
        <DateField
          source="registration_completed_date"
          showTime
        />
        <TextField source="distributor_id" label="Distributor ID" />
        <FunctionField
          source="email_list"
          render={(record) => {
            const emails = record.email_list;
            if (!emails || typeof emails !== "object") return null;
            return Object.keys(emails).filter(key => emails[key] === true).join(", ");
          }}
        />
        <TextField source="operation_type" />
        <DateField
          source="changed_at"
          showTime
        />
      </Datagrid>
    </ReferenceManyField>
  );
};

export default GetInvitationHistory;
